import { render } from "./AppWidgetWithoutIcon.vue?vue&type=template&id=a3f40c02"
import script from "./AppWidgetWithoutIcon.vue?vue&type=script&lang=js"
export * from "./AppWidgetWithoutIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__